import { render, staticRenderFns } from "./TableBudget.vue?vue&type=template&id=5fbe3292&scoped=true&"
import script from "./TableBudget.vue?vue&type=script&lang=js&"
export * from "./TableBudget.vue?vue&type=script&lang=js&"
import style0 from "./TableBudget.vue?vue&type=style&index=0&id=5fbe3292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe3292",
  null
  
)

export default component.exports